module.exports = __webpack_public_path__ + "static/media/Yanch Homes Inc. -  summary of Allegations (1).2ab2d976.pdf";